export const LAST_REVIEWED = 'October 2026';
export const SITE_URL = 'mohswoundcare.com';
